import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  state: {
    reopenVisible: false,
    submittedSuccess: null,
    dangerVisible: true,
    token: '',
    data: {},
    taxRateExempt: null,
    taxRatesAggregates: null,
    files: [],
    acceptStatus: null,
    showQuoteInBX: false
  },
  strict: debug,
  mutations: {
    setAcceptStatus (state, acceptStatus) {
      let keyMap = {'yes': 'Opened', 'no': 'Declined', 'later': 'Pending'}
      Vue.set(state, 'data.recipient.quoteStatus', keyMap[acceptStatus])
    },
    setQuoteStatus (state, status) {
      state.data.recipient.quoteStatus = status
    },
    updateStep (state, step) {
      // Vue.set(state, 'step', step)
      state.data.recipient.step = step
    },
    updateStepReached (state, stepReached) {
      // Vue.set(state, 'stepReached', stepReached)
      state.data.recipient.stepReached = stepReached
    },
    updateReopenVisible (state, show) {
      Vue.set(state, 'reopenVisible', show)
    },
    hideWarning (state, show) {
      state.data.recipient.dateSubmitted = null
      Vue.set(state, 'submittedSuccess', null) // False will show error so set to null if wanting to reset submit btn
    },
    submittedSuccess (state, value) {
      Vue.set(state, 'submittedSuccess', value)
    },
    updateShowQuoteInBX (state, value) {
      Vue.set(state, 'showQuoteInBX', value)
    },
    hideDanger (state, show) {
      Vue.set(state, 'dangerVisible', false)
    },
    storeToken (state, id) {
      Vue.set(state, 'token', id)
    },
    storeData (state, data) {
      Vue.set(state, 'data', data)

      if (data.taxRates) {
        let taxRates = JSON.parse(data.taxRates)
        let expenseRates = taxRates.filter(item => item.type === 1)

        // Store the single exempt rate
        let exemptArray = expenseRates.filter(item => item.exempt)
        let exempt = (exemptArray && (exemptArray.length > 0)) ? exemptArray[0] : null
        if (exempt && exempt.code) {
          exempt.selected = '["' + exempt.code + '"]'
        }
        Vue.set(state, 'taxRateExempt', exempt)

        // Aggregate together details about the non-exempt rates
        let taxRatesAggregates = {}
        let nonExemptExpenseRates = expenseRates.filter(item => !item.exempt)
        for (let i = 0; i < 5; i++) {
          let aggregate = nonExemptExpenseRates.filter(neer => neer.defaults.includes(i)).reduce((agg, item) => {
            agg.codes.push(item.code)
            agg.rate = (agg.rate * 100 + item.rate * 100) / 100

            return agg
          }, {
            codes: [],
            rate: 0
          })
          taxRatesAggregates[`${i}`] = aggregate.codes.length ? {
            codes: aggregate.codes.join(', '),
            rate: aggregate.rate,
            selected: JSON.stringify(aggregate.codes)
          } : null
        }

        Vue.set(state, 'taxRatesAggregates', taxRatesAggregates)
      }
    },
    updateDateSubmitted (state, date) {
      state.data.recipient.dateSubmitted = date
    },
    updateItemAmount (state, obj) {
      state.data.items[+obj.index].response.total = +obj.value
    },
    updateItemResponseTaxStatus (state, obj) {
      state.data.items[+obj.index].response.taxStatus = +obj.value
    },
    updateItemResponseTaxRates (state, obj) {
      state.data.items[+obj.index].response.taxRates = obj.value
    },
    updateItemTax (state, obj) {
      state.data.items[+obj.index].response.tax = +obj.value
    },
    updateItemTotalIncTax (state, obj) {
      state.data.items[+obj.index].response.totalIncTax = +obj.value
    },
    updateRecipeItemAmount (state, obj) {
      state.data.items[+obj.index].recipeItems[+obj.rIndex].response.total = +obj.value
    },
    updateRecipeItemResponseTaxStatus (state, obj) {
      state.data.items[+obj.index].recipeItems[+obj.rIndex].response.taxStatus = +obj.value
    },
    updateRecipeItemResponseTaxRates (state, obj) {
      state.data.items[+obj.index].recipeItems[+obj.rIndex].response.taxRates = obj.value
    },
    updateRecipeItemTax (state, obj) {
      state.data.items[+obj.index].recipeItems[+obj.rIndex].response.tax = +obj.value
    },
    updateRecipeItemTotalIncTax (state, obj) {
      state.data.items[+obj.index].recipeItems[+obj.rIndex].response.totalIncTax = +obj.value
    },
    updateRecipientTaxRegistration (state, value) {
      state.data.recipient.isRegisteredForTax = value
    },
    updateRecipientTotalAmount (state, value) {
      state.data.recipient.totalAmount = value
    },
    updateRecipientResponseText (state, value) {
      state.data.recipient.responseText = value
      // Vue.set(state, 'data.recipient.responseText', value)
    },
    updateRecipientEmailCC (state, value) {
      state.data.recipient.emailCC = value
      // Vue.set(state, 'data.recipient.emailCC', value)
    },
    updateFiles (state, files) {
      state.files = files
    }
  }
})

export default store
